var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{attrs:{"indeterminate":"","color":"#89a0ca","size":"33"}},[_c('v-img',{attrs:{"height":"21","width":"21","src":require("@/assets/img/icon-128-load.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }